module.exports = __webpack_public_path__ + "img/topic-sign-done.8af8cee7.png";